


<!--<div class="btn-toolbar flex-wrap floatR" >-->
  <!--&lt;!&ndash;<div class="btn-group sm-m-t-10">&ndash;&gt;-->
  <!--<div class="btn-group sm-m-t-10 floatR">-->
    <!--<button type="button" class="btn btn-primary btn-xs floatR" [ngClass]="radioModel =='fr' ? 'active' : ''" (click)="changeLang('fr')">Fr</button>-->
    <!--<button type="button" class="btn btn-primary btn-xs floatR "  [ngClass]="radioModel =='en' ? 'active' : ''"  (click)="changeLang('en')">En</button>-->
    <!--<button type="button" class="btn btn-primary btn-xs floatR"  [ngClass]="radioModel =='es' ? 'active' : ''" (click)="changeLang('es')">Es</button>-->
  <!--</div>&nbsp;&nbsp;-->

<!--</div>-->

<div class="floatR btnLangGroup" *ngIf="!siteMenu; else sideMenu" >
  <!--<div class="btn-group sm-m-t-10">-->
  <div class="">
    <button type="button" class="btn btn-primary btn-xs btnLang floatR" [ngClass]="radioModel =='fr' ? 'btnLangA' : ''" (click)="changeLang('fr')">Fr</button>
  </div> <div class="">
    <button type="button" class="btn btn-primary btn-xs btnLang floatR "  [ngClass]="radioModel =='en' ? 'btnLangA' : ''"  (click)="changeLang('en')">En</button>
  </div> <div class="">
    <button type="button" class="btn btn-primary btn-xs btnLang floatR"  [ngClass]="radioModel =='es' ? 'btnLangA' : ''" (click)="changeLang('es')">Es</button>
  </div>&nbsp;&nbsp;

</div>

<ng-template #sideMenu>
  <!--<div class="btn-group sm-m-t-10">-->
  <div class="btn-group m-0">
    <button type="button" class="btn btn-primary btn-xs btnLang " [ngClass]="radioModel =='fr' ? 'btnLangA' : ''" (click)="changeLang('fr')">Fr</button>
    <button type="button" class="btn btn-primary btn-xs btnLang"  [ngClass]="radioModel =='en' ? 'btnLangA' : ''"  (click)="changeLang('en')">En</button>
    <button type="button" class="btn btn-primary btn-xs btnLang"  [ngClass]="radioModel =='es' ? 'btnLangA' : ''" (click)="changeLang('es')">Es</button>
  </div>
</ng-template>
